'use strict';
angular.module('companyManageModule', []).
controller('companyManageController', ['$scope', '$timeout', '$q', '$stateParams', '$location', '$state', '$window', 'treeService', 'trsHttpService', 'modalDialog', 'trsspliceString', 'trsTransferService', 'trsGroupTreeLocationService', 'localStorageService', 'departmentManuCommonService',
    function($scope, $timeout, $q, $stateParams, $location, $state, $window, treeService, trsHttpService, modalDialog, trsspliceString, trsTransferService, trsGroupTreeLocationService, localStorageService, departmentManuCommonService) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化状态22
         */
        function initStatus() {
            $scope.data = {
                selectedArray: [],
            };
            $scope.queryCompanyParams = {
                serviceid: "mlf_departdoc",
                methodname: "queryDeparts",
                ParentId: 0,
                SearchKey: '',
            };
        };

        /**
         * [initData description]初始化数据
         */
        function initData() {
            requestData();
        };

        /**
         * [requestData description] 获取单位
         * @return {[type]} [description]
         */
        function requestData() {
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.queryCompanyParams, "get").then(function(data) {
                if (data.PAGER == undefined) { //兼容后端返回无数据时,返回数据结构不一致问题
                    $scope.lists = data;
                } else {
                    $scope.lists = [];
                }
                $scope.data.selectedArray = [];
            });
        }
        /**
         * [departSearch description;检索:根据用户真实姓名模糊查询用户列表(全文检索)]
         * @param  {[type]} ev [description:按下空格也能提交]
         */
        $scope.departSearch = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                $scope.queryCompanyParams.SearchKey = $scope.data.keywords;
                requestData();
            }
        };
        /**
         * [getDepartIds description:删除部门]
         */
        function deleteCompanyData() {
            var selectedIds = trsspliceString.filter($scope.data.selectedArray, "DEPARTMENTALDOCID", "");
            $scope.deleteCompanyParams = {
                serviceid: "mlf_departdoc",
                methodname: "removeDeparts",
                DepartmentaldocIds: selectedIds.join(",")
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.deleteCompanyParams, 'get').then(function(data) {
                if (data.ISSUCCESS == 'true') {
                    modalDialog.alertType('删除成功', '', 'success', false, function() {
                        requestData();
                        $scope.$root.$broadcast("companyManageList", true); //通知左侧导航也更新数据
                    });
                }
            });
        }
        /**
         * [isShowCompany description:是否显示单位]
         */
        function isShowCompany(type, ids) {
            $scope.isShowDepartsParams = {
                serviceid: "mlf_departdoc",
                methodname: type,
                DepartmentaldocIds: ids
            };
            var confirmTips = type == 'displayDeparts' ? '显示' : '隐藏';
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.isShowDepartsParams, 'get').then(function(data) {
                if (data.ISSUCCESS == 'true') {
                    modalDialog.alertType(confirmTips + '成功', "", "success", false, function() {
                        requestData();
                    });
                }
            });
        }
        /**
         * [switchBen description单选] 点击显示或者隐藏单位
         */
        $scope.switchBtn = function(item) {
            var confirmInfo = item.ISHIDE == '1' ? "选中单位开启显示，是否继续？" : "选中单位将被隐藏，是否继续？";
            modalDialog.alertType(confirmInfo, "", "ask", true, function() {
                if (item.ISHIDE == '0') {
                    isShowCompany('hideDeparts', item.DEPARTMENTALDOCID);
                    item.ISHIDE = '1';
                } else {
                    isShowCompany('displayDeparts', item.DEPARTMENTALDOCID);
                    item.ISHIDE = '0';
                }
            });
        };
        /**
         * [selectAll description:全选]
         */
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.lists.length ? [] : [].concat($scope.lists);
        };
        /**
         * [selectDoc 单选]
         * @param  {[type]} item [description：单个对象]
         */
        $scope.selectDoc = function(item) {
            if ($scope.data.selectedArray.indexOf(item) < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
            }
        };
        /**
         * [createNewCompany description] 新建单位
         */
        $scope.createNewCompany = function() {
            departmentManuCommonService.createCompanyManu("", "create", 'company').then(function(data) {
                requestData();
                $scope.$root.$broadcast("companyManageList", true); //通知左侧导航也更新数据
            });
        };
        /**
         * [editCompany description] 新建单位
         */
        $scope.editCompany = function(item) {
            departmentManuCommonService.createCompanyManu(item, "edit", 'company').then(function(data) {
                requestData();
                $scope.$root.$broadcast("companyManageList", true); //通知左侧导航也更新数据
            });
        };
        /**
         * [deleteCompany description]删除单位
         */
        $scope.deleteCompany = function() {
            modalDialog.alertType("", "删除单位将不可恢复，是否继续？", "warning", true, function() {
                deleteCompanyData();
                $scope.$root.$broadcast("companyManageList", true); //通知左侧导航也更新数据
            });
        };
        /**
         * [hideCompany description]隐藏单位
         */
        $scope.hideCompany = function() {
            var selectedIds = trsspliceString.filter($scope.data.selectedArray, "DEPARTMENTALDOCID", "");
            modalDialog.alertType("选中单位将被隐藏，是否继续？", "", "ask", true, function() {
                isShowCompany('hideDeparts', selectedIds.join(","));
            });
        };
        /**
         * [initShowCompany description]显示单位
         */
        $scope.initShowCompany = function() {
            var selectedIds = trsspliceString.filter($scope.data.selectedArray, "DEPARTMENTALDOCID", "");
            modalDialog.alertType("选中单位开启显示，是否继续？", "", "ask", true, function() {
                isShowCompany('displayDeparts', selectedIds.join(","));
            });
        };
        /**
         * [dragoverCallback description;允许拖拽]
         */
        $scope.dragoverCallback = function(event, index, external, type) {
            return true;
        };
        /**
         * [dragStart description;拖拽开始]
         */
        $scope.dragStart = function(event, item, index) {
            $scope.status.dragStartIndex = index;
        };
        /**
         * [dragStdropCallbackart description;拖拽结束]
         */
        $scope.dropCallback = function(event, index, item, external, type, allowedType) {
            if ($scope.status.dragStartIndex == index) {
                return;
            }
            var params = {
                serviceid: 'mlf_departdoc',
                methodname: 'orderDepartDocs',
                StartDepartId: $scope.lists[$scope.status.dragStartIndex].DEPARTMENTALDOCID,
                EndDepartId: $scope.status.dragStartIndex > index ? $scope.lists[index].DEPARTMENTALDOCID : $scope.lists[index - 1].DEPARTMENTALDOCID,
                ParentId: '0',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function() {
                requestData();
                $scope.$root.$broadcast("companyManageList", true); //通知左侧导航也更新数据
            });
        };


    }
]);